import React from "react";
import { Link } from "react-router-dom";

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer bg-white py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer">
        {/* begin::Container */}
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}>
          {/* begin::Copyright */}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-2">
              Copyright {today} &copy; Weehena ERP.{" "}
              <a
                href="http://vision8.io/"
                target="_blank"
                rel="noopener noreferrer">
                Powered by VISION8
              </a>
            </span>
            {` `}
            {/* <a
              href="http://keenthemes.com/metronic"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            > */}
            {/* Keenthemes */}
            {/* </a> */}
          </div>
          {/* end::Copyright */}
          {` `}
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2">
            {/* <a
              href="https://weehenafarms.com/who-we-are/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0">
              About
            </a> */}
            {/* <a
              href="http://keenthemes.com/metronic"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link px-3"
            >
              Team
            </a> */}
            <a
              href="https://weehenafarms.com/weehena-farms-contact/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pl-3 pr-0">
              Contact
            </a>
            <Link style={{ cursor: "none" }} className="nav-link pl-3 pr-0">
              V2.0.6
            </Link>
          </div>
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
    </>
  );
}
